import {
  deleteEventSongAdmin as deleteEventSongAdminApi,
  deleteEventSongGuest as deleteEventSongGuestApi
} from "../../../../helpers/event_helper.js";
import { eventSongDeleteError, eventSongDeleteSuccess } from "./reducer";

export const deleteEventSong = (id, guestId) => async (dispatch) => {
  try {
    let response;

    if (guestId) {
      response = deleteEventSongGuestApi(id,{id: guestId});
    } else {
      response = deleteEventSongAdminApi(id);
    }
    const data = await response;
    if (data) {
      dispatch(eventSongDeleteSuccess());
    }
  } catch (error) {
    dispatch(eventSongDeleteError(error));
  }
};
